module.exports = __webpack_public_path__ + "sprite/confetti-1.json";


//////////////////
// WEBPACK FOOTER
// ./sprite/confetti-1.json
// module id = 127
// module chunks = 3